import React, { useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text } from "grommet";
import { TeamViewModel } from "./TeamsStore";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt from "../components/ParallaxTilt";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { normalizeColor } from "grommet/utils";
import Theme from "../utils/Theme";
import { useDarkMode } from "../components/DarkModeSwitch";
import Avatar from "react-avatar";

export const TeamCard: React.FC<{ team: TeamViewModel; width?: number }> = ({ team, width }) => {
    const [isDarkMode] = useDarkMode();
    const background = normalizeColor("background", Theme, isDarkMode);
    return (
        <Link to={`/teams/${team.id}`} style={{ textDecoration: "none", color: "unset" }}>
            <ParallaxTilt2 style={{ backgroundImage: "url(" + team.splashUri + ")", backgroundColor: background }} holo={team.rating == 5} sparkle={team.rating == 5}>
                <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"}>
                    <CardBody align="center" justify="center">
                        <Box align="center">{team.logoUri ? <Image src={team.logoUri} fit="contain" width="90%" height="90%" /> : <Avatar style={{ objectFit: "contain" }} name={team.name} round="10px" />}</Box>
                    </CardBody>
                    <CardHeader pad="small" justify="center" fill="horizontal">
                        <Text textAlign="center">{team.name}</Text>
                    </CardHeader>
                    <CardFooter pad="small" background="background-front">
                        <Box direction="row" gap="small" justify="between" fill="horizontal">
                            <Box direction="row" gap="small" align="center">
                                <FontAwesomeIcon icon={["fad", "swords"]}></FontAwesomeIcon>
                                <Text>{team.matchesPlayed}</Text>
                            </Box>
                            <Box direction="row" gap="small" align="center">
                                <Text>{team.matchesWon}</Text>
                                <FontAwesomeIcon icon={["fad", "trophy"]}></FontAwesomeIcon>
                            </Box>
                        </Box>
                    </CardFooter>
                </Card>
            </ParallaxTilt2>
        </Link>
    );
};
